import { FormikProps } from 'formik';
import React from 'react'
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMPassword from 'src/components/UI/atoms/formFields/ATMPassword/ATMPassword';


type Props = {
  formikProps: FormikProps<any>;
  onClose : any
};

const ResetPasswordForm = ({ formikProps, onClose}: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">Reset Password</div>
        <button
          type="button"
          className="hover:bg-hover p-2 rounded"
          onClick={onClose}
        >
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        {/* Old Password */}
        <div>
          <ATMPassword
            name="password"
            value={values.password}
            onChange={(e) => setFieldValue("password", e.target.value)}
            label="Password"
            required
            placeholder="Enter password"
            onBlur={handleBlur}
          />
        </div>      
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>

  )
}

export default ResetPasswordForm
